<ng-template [ngIf]="inserimento">
    <div class="col-sm-12 coldx" 
        [ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
        <h4 *ngIf="title">Aggiungi Avviso di parcella</h4>
        <form class="cerca_grey">
            <div class="row">
                <p class="col-sm-12">
                    <label for="cerca-avv-lbl">Cerca</label> <input id="cerca-avv-lbl" type="text" #searchItem (keyup)="0"
                        class="form-control" placeholder="Inserisci nome e cognome" />
                </p>
            </div>
        </form>
        <ng-template [ngIf]="legaliAll.length > 0">
        <ul id="controparticollapse" class="controparti">
            <ng-template ngFor
                let-legaleIncaricato [ngForOf]="legaliAll  | searchFilter : searchItem.value : 'legale.nominativo' ">

            <li class="panel">
                <div class="controparte">
                    <div>
                        <p class="col-xs-12 col-sm-2">
                            <button class="btn btn-primary associa"
                                (click)="associaLegale(legaleIncaricato);" type="submit">Associa</button>
                        </p>
                        <h4 class="titolo col-xs-12 col-sm-3">
                            {{legaleIncaricato.legale?.nominativo}}
                        </h4>
                        <ng-template [ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                        <p class="col-xs-12 col-sm-4 matricola">
                            CF: <strong>{{legaleIncaricato.legale?.codiceFiscale}}</strong>
                        </p>
                        </ng-template>
                        <ng-template [ngIf]="legaleIncaricato.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                        <p class="col-xs-12 col-sm-3 matricola">
                            P.IVA: <strong>{{legaleIncaricato.legale?.partitaIva}}</strong>
                        </p>
                        </ng-template>
                        <p class="col-xs-12 col-sm-3 matricola">
                            <strong>{{legaleIncaricato.categoriaLegaleIncaricato.label}}</strong>
                        </p>
                    </div>
                </div>
            </li>
            </ng-template>
        </ul>
        </ng-template>
        <ng-template [ngIf]="legaliAll.length == 0 && msgNoBeneficiari">
        <p>{{msgNoBeneficiari}}</p>
        </ng-template>
    </div>
    </ng-template>

    <ng-template [ngIf]="parcellaStragiudizialeForm">

    <div class="col-xs-12 col-sm-12 coldx" 
        [ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
        <h4 *ngIf="title">{{title}}</h4>
        <div class="tab-content">
            <form [formGroup]="parcellaStragiudizialeForm">
                <div class="row">
                    <ng-template [ngIf]="!inserimento">
                    <div comboModInput class="col-xs-12 col-sm-4" [labelInput]="'Legale'"	formControlName="legale"
                        [labelOption]="'legale.nominativo'"  [objectReference]="request.legale"
                        (onReturn)="request.legale = $event" [optionsCombo] ="legaliOptions"></div>
                    </ng-template>


                    <ng-template [ngIf]="inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
                    <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Cognome e nome'" [valueInput]="request.legale?.legale.nominativo"></div>

                    </ng-template>

                    <ng-template [ngIf]="inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
                    <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Ragione sociale'" [valueInput]="request.legale?.legale.ragioneSociale"></div>
                    <div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Tipo Legale'"
                        [valueInput]="request.legale?.categoriaLegaleIncaricato.label"></div>
                    </ng-template>


                    <div textInput [class]="(inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA) ? 'col-sm-3' : 'col-sm-4'" [labelInput]="'Numero'"
                        formControlName="numeroParcella"
                        [(ngModel)]="request.numeroParcella"></div>

                    <div datePickerInput [class]="(inserimento && request.legale?.legale.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA) ? 'col-sm-3' : 'col-sm-4'" [labelInput]="'Data'"
                        formControlName="dataParcella" [(ngModel)]="request.dataParcella"
                        [control]="parcellaStragiudizialeForm.controls['dataParcella']"
                        [mandatory]="true"></div>

                </div>
                <hr>

                <div class="row">
                    <div class="col-xs-12 col-sm-4"></div>
                             <div textInputCurrency class="col-sm-4" [labelInput]="'Compenso'"
                            formControlName="compensoPattuito" [location]="'SezioneEconomica'"
                            [control]="parcellaStragiudizialeForm.controls['compensoPattuito']"
                            [(ngModel)]="importoPattuito" (onReturn)="setCompensoPattuito($event)"></div>
                    <div class="col-sm-4"></div>

                </div>
                <hr>
                <div class="container_conteggi">
                    <h5>
                        <strong>Spese</strong>
                    </h5>
                    <div
                        textInputCurrency [control]="parcellaStragiudizialeForm.controls['spesaEsente']"
                        [labelInput]="'Spese esenti art. 15 DPR 633/72'"
                        formControlName="spesaEsente"
                        [(ngModel)]="request.spesa.spesaEsente"></div>
                    <div
                        textInputCurrency [control]="parcellaStragiudizialeForm.controls['spesaTrasferta']"
                        [labelInput]="'Spese di trasferta art. 27'"
                        formControlName="spesaTrasferta"
                        [(ngModel)]="request.spesa.spesaTrasferta"></div>
                    <div
                        textInputCurrency [control]="parcellaStragiudizialeForm.controls['altraSpesaImponibile']"
                        [labelInput]="'Altre spese imponibli (non relative a trasferte)'"
                        formControlName="altraSpesaImponibile"
                        [(ngModel)]="request.spesa.altraSpesaImponibile"></div>
                    <div
                        textInputCurrency [control]="parcellaStragiudizialeForm.controls['percSpesaGenerale']"
                        [labelInput]="'Spese generali % art. 2'" [maxValue]="100" [isNaturalNumber]="true"
                        formControlName="percSpesaGenerale"
                        [(ngModel)]="request.spesa.percSpesaGenerale"></div>

                    <div
                        textInputCurrency [control]="parcellaStragiudizialeForm.controls['contributoUnificato']"
                        [labelInput]="'Contributo unificato'"
                        formControlName="contributoUnificato"
                        [(ngModel)]="request.contributoUnificato"></div>

                    <div textInputCurrency [labelInput]="'Maggiorazione p.d. %'" formControlName="maggiorazione" 
                        [control]="parcellaStragiudizialeForm.controls['maggiorazione']"
                        [(ngModel)]="request.maggiorazione" [maxValue]="100" [isNaturalNumber]="true">
                    </div>
                </div>

                <div class="container_conteggi">
                    <h5>
                        <strong>Accessori</strong>
                    </h5>

                    <div class="row">
                        <div class="parcella_accessori col-sm-offset-2">
                            <div singleCheckBoxModInput class=" col-xs-2 col-sm-2" [layout]="'no-label'" 
                                [labelInput]="'IVA'"
                                idInput="flagIva" formControlName="flagIva"
                                [labelChecked]="'IVA'" [labelNotChecked]="'IVA'"
                                [objectReference]="request.flagIva" [showLabel]="true"
                                (onReturn)="request.flagIva = $event; changeFlagIva($event)"></div>

                            <div comboModInput class="col-xs-10 col-sm-3" [labelInput]="''"
                                formControlName="iva" [submitPending]="!request.flagIva" [mandatory]="request.flagIva"
                                [labelOption]="'valore'" [labelInput]="'seleziona percentuale IVA'" [objectReference]="request.iva"
                                (onReturn)="request.iva = $event" [optionsCombo] ="ivaOptions"
                                [location]="'accessori'"></div>

                            <div class="col-xs-2 col-sm-2" singleCheckBoxModInput
                                [labelChecked]="'CPA'" [labelNotChecked]="'CPA'"
                                [layout]="'no-label'" [labelInput]="'CPA'"
                                idInput="flagCpa" formControlName="flagCpa"
                                [objectReference]="request.flagCpa" [showLabel]="true"
                                (onReturn)="request.flagCpa = $event; changeFlagCpa($event)"></div>

                            <div comboModInput class="col-xs-10 col-sm-3" [labelInput]="''"
                                formControlName="cpa" [labelInput]="'seleziona percentuale CPA'" [submitPending]="!request.flagCpa"
                                [mandatory]="request.flagCpa"
                                [labelOption]="'valore'" [objectReference]="request.cpa"
                                (onReturn)="request.cpa = $event" [optionsCombo] ="cpaOptions"
                                [location]="'accessori'"></div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="parcella_accessori">
                        <div singleCheckBoxModInput class="col-xs-12 col-sm-7 col-sm-offset-5 listcheckbox"
                            [labelChecked]="'Ritenuta d\'\acconto'" [labelNotChecked]="'Ritenuta d\'\acconto'"
                            [labelInput]="'Ritenuta d\'\acconto'" [layout]="'no-label'" idInput="flagRitenutaAcconto" [showLabel]="true"
                            formControlName="flagRitenutaAcconto"
                            [objectReference]="request.flagRitenutaAcconto"
                            (onReturn)="request.flagRitenutaAcconto = $event"></div>
                    </div>
                </div>

                <div class="row">
                    <p class="col-sm-3 col-xs-6">
                        <ng-template [ngIf]="inserimento">
                            <button type="button" (click)="goToAssociaLegale();"
                                class="btn btn-outline-secondary btn-block">Indietro</button>
                        </ng-template>
                        <ng-template [ngIf]="!inserimento">
                            <button type="button" class="btn btn-outline-secondary btn-block"
                                (click)="createForm();">Reset</button>
                        </ng-template>
                    </p>
                    <p class="col-sm-3 col-xs-6 col-sm-offset-6">
                        <button (click)="calcolaCompenso(request.legale);" type="button" [disabled]="!parcellaStragiudizialeForm.valid"
                            class="btn btn-primary btn-block">Calcola il compenso</button>
                    </p>
                </div>
            </form>
        </div>
    </div>

    <div class="col-sm-12 coldx" id="pannello11"
        [ngStyle]="{ 'display' : ( visibleToggleRiepilogo ? 'block' : 'none') }">
        <h4>Riepilogo Avviso di parcella</h4>
        <div class="tab-content">
            <form (ngSubmit)="save();">

                <div *ngIf="riepilogo" avviso-parcella-riepilogo-form [parcellaStragiudiziale]="riepilogo"></div>
                <div class="row">
                    <p class="col-sm-3 col-xs-6">
                        <button type="button" class="btn btn-outline-secondary btn-block"
                            (click)="goToForm();">Indietro</button>
                    </p>
                    <p submitButton
                        class="col-sm-3 col-xs-6 col-sm-offset-6"
                        [labelButton]="'Salva'">
                    </p>
                </div>
            </form>
        </div>
    </div>
    </ng-template>
